import { render, staticRenderFns } from "./FrenchWindowLockDamage.vue?vue&type=template&id=5a9551a5&scoped=true"
import script from "./FrenchWindowLockDamage.vue?vue&type=script&lang=ts"
export * from "./FrenchWindowLockDamage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9551a5",
  null
  
)

export default component.exports